import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { ConfigService } from '../../../common/services/config/config.service';
import { ChatBotStyleAndConfig } from '../../modals/style-and-config/style-config';
import { Subscription, firstValueFrom } from 'rxjs';
import { ChatStateService } from '../../services/app-state-services/chat-main/chat-state.service';
import { environment } from '../../../../environments/environment';
import { ChatService } from '../../services/chat/chat.service';
import { SessionService } from '../../services/app-state-services/session/session.service';

@Component({
  selector: 'app-chat-welcome',
  standalone: false,
  templateUrl: './chat-welcome.component.html',
  styleUrl: './chat-welcome.component.scss'
})
export class ChatWelcomeComponent {
@Output() navigateToChatWindow = new EventEmitter<boolean>();
chatBotStyles!: ChatBotStyleAndConfig;
customerName: string = "";
isLoading: boolean = true;
private subscriptions: Subscription[] = [];
  
constructor(
  private _configService: ConfigService,
  private _chatStateService: ChatStateService,
  private _chatService: ChatService,
  private _sessionService: SessionService,
  private _cdr: ChangeDetectorRef
) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this._configService.chatBotStyleAndConfig$.subscribe((config) => this.chatBotStyles = config)
    );
    this.subscriptions.push(
      this._configService.configLoading$.subscribe((loading) => {
        this.isLoading = loading;
        this._cdr.detectChanges();
      })
    );
  }

  startChat(){
    this._chatStateService.setCustomerName(this.customerName.trim());
    this._chatStateService.setIsWelcomeScreen(false);
    this.handleStartChat();
  }

  async handleStartChat() {
    this._sessionService.removeContextInfo();
    const payload = {
      intent: "",
      ownerId: this.chatBotStyles.tenantCode,
      customerName: this.customerName || "",
    };
    try {
      const response = await firstValueFrom(this._chatService.startChatWithIntent(payload));
      this._sessionService.setContextInfo(JSON.stringify(response));
      this._chatStateService.setCustomerWelcomeMessage(response.customerWelcomeMessage);
      const currentQnA = this._chatStateService.getQna();
      currentQnA.answer.message = response.customerWelcomeMessage;
      currentQnA.answer.receivedFrom = "VirtualAgent";
      this._chatStateService.addEntryToUsersQna(currentQnA);
      this._chatStateService.updateQueryResponseId(currentQnA.id, "ANSWER_id");
      return response;
    } catch (error) {
      console.error("Error starting chat:", error);
    }
  }

  handleKeyDownEnter(event: KeyboardEvent) {

    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if(this.customerName.trim()) {
        this.startChat();
      }
    }
  }

  getBaseAssetUrl(path: string) {
    return this._sessionService.getBaseAssetUrl() + path;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}

